import jQuery from 'jquery';
let $ = jQuery;
import __extends from 'LIBS/extend.js';

import "LIBS/jquery.showhtml.js";
// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";
import AkamaiPlayer from 'HSNDIR/Widget/VideoPlayers/AkamaiPlayer.js';

/**
* class HSN.VideoModal
* Encapsulates the functionality of a video dialog
**/
HSN.VideoModal = (function (parent) {
    __extends(videoModal, parent);

    var currentModal = null;
    var videoModalScope;

    function videoModal () {
        var modal = videoModal.__super__.constructor.call(this);
        videoModalScope = this;
        this.Close.off();
        eventHandlers(this);
        return modal;
    }

    function eventHandlers (modal) {
        currentModal = modal;

        $(modal.Close)
            .on('click', function (e) {
                closeModal(e, modal);
                e.preventDefault();
                e.stopPropagation();
            })
            .on('keyup', function (e) {
                if (e.key === 'Tab') {
                    modal.Close.focus();
                    e.preventDefault();
                }
            })
            .on('keydown', function (e) {
                if (e.key === 'Tab') {
                    if (e.shiftKey) {
                        e.preventDefault();
                    }
                }
                else if (e.key === 'Enter') {
                    closeModal(e, modal);
                    e.preventDefault();
                    e.stopPropagation();
                }
            });        
    }

    function closeModal(e, modal) {
        var mdl;
        if (modal) {
            mdl = modal;

            var playerInstance = getModal();
            playerInstance.videoPlayer.stop();
            modal.Hide();
        }
        else {
            mdl = getModal();
            mdl.Hide();
        }

        if (mdl.elementToFocusOnClose) {
            mdl.elementToFocusOnClose.focus();
        }
    }

    function getModal () {
        return currentModal;
    }

    videoModal.prototype._show = function (videoData, w, h, showDisclaimer, hideLogo) {
        var scope = this;
        scope.Root.removeClass('loading');
        scope.Root.css("overflow-y", "hidden");
        
        //video div must have a unique id to allow multiple videos
        var playerId = 'akamai-player' + Math.floor(Math.random() * (99999 - 0) + 0);
        var disclaimer = (showDisclaimer) ? "<div id='video-disclaimer'>Prices and the availability of FlexPay shown on the previously recorded video may not represent the current price options. Consult the product page for current price options.</div>" : "";
        var videoPlayerElement = $('<div/>').attr('id', playerId);
        var ada = $("<div class='endOfModal' tabindex='0'></div>");
        var videoContainer = $('<div/>').css({'width': w, 'height': h, 'margin': '23px 23px 50px 23px' });        
        videoContainer.attr('class', 'akamai-player-container');
        videoContainer.append(videoPlayerElement, disclaimer, ada); 
                
        this.Content.showHtml(
             videoContainer, 0,
            function () {
                scope.Center();
                scope.Content.animate(
                    { opacity: 1 },
                    {
                        complete: function () {
                            scope.Close[0].focus();                            

                            $('.endOfModal', scope.Root)
                                .off('focus')
                                .on('focus', function (e) {
                                    scope.Close[0].focus();                                    
                                    e.preventDefault();                                    
                                })
                                .off('keydown')
                                .on('keydown', function (e) {
                                    scope.Close[0].focus();
                                    e.preventDefault();
                                });                            
                        }
                    }
                );
                
                //check for media property - if one doesn't exist, create it (may come from CMS)
                if(!videoData.hasOwnProperty("media")) {
                    videoData.media = {
                        title: videoData.analyticName,
                        source:[{ src : videoData.httpUrl, type : "video/mp4" }]
                    }
                }

                //check for custom captions
                if (videoData.hasOwnProperty('customCaptions') && videoData.customCaptions)  {
                    var parsedAsset = videoData.httpUrl.substring(videoData.httpUrl.lastIndexOf('/') + 1);
                    var assetId = parsedAsset.split('.')[0];
                    videoData.captioning = {enabled : true}
                    videoData.media.track = [{ 
                        kind: "captions", 
                        type: "application/x-subrip", 
                        srclang: "en", 
                        src: "https://" + location.host + "/services/getcaptions/asset/" + assetId 
                    }];  
                }

                videoData.branding = { logo : "../../assets/img/logo_video_bug.png" };
                if(hideLogo) {
                    videoData.branding = { logo: "" };
                }
                   
                //init video by passing in video obj and dom id
                videoData.element = playerId;
                videoModalScope.videoPlayer = new AkamaiPlayer(videoData);

                var playerInstance = videoModalScope.videoPlayer.getVideoPlayer();
                playerInstance.addEventListener("ended", function () {
                    closeModal();
                });
            }
        );
    };

    videoModal.prototype.getVideoPlayer = function () {
        return videoModalScope.videoPlayer;
    };

    return videoModal;
})(HSN.Modal);



// WEBPACK FOOTER //
// ./assets/js/HSN/VideoModal.js